<template>
  <v-container v-if="hasGroups" class='ml-0 pl-0 theme--light'>
    <v-layout>
      <div class="text-left">
        <h4 class="mb-4">Group Membership Overview</h4>
        <ul class="membershipList">
          <li v-for="group in groups">
            <a :href="groupUrl(group.id)">{{ group.name }}</a>
          </li>
        </ul>
      </div>
    </v-layout>
  </v-container>
</template>

<style lang="scss" scoped>
  @import "src/styles/variables.scss";
   h4 {

  }
  ul.membershipList {
    list-style-type: none;
    padding: 0;
    margin: 0;
    li {
      padding-bottom: 1rem;
    }
  }
</style>

<script>
import GroupService from "@/services/GroupService";

export default {
  props: ["userId"],
  data() {
    return {
      groups: []
    };
  },
  computed: {
    hasGroups() {
      return this.groups.length > 0;
    }
  },
  // The mounted lifecycle doesn't update the component when the userId prop changes.
  // This watcher will update the component when the userId prop changes to address that.
  watch: {
    userId: function(newVal, oldVal) {
      this.getProfile(newVal);
    }
  },
  methods: {
    groupUrl(groupId) {
      return '/group/' + groupId;
    },
    getProfile(id) {
      // 2022-11-09: I don't like this here, but it's preventing
      // an unecessary network call that also results in a console error message
      // when id is undefined.
      if (!id) {
        return false;
      }
      return GroupService.getUserGroups(id).then(
        response => {
          this.groups = response;
        },
        response => {
          console.error("[error] getProfile", response);
        }
      );
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getProfile(this.userId);
    });
  }
};
</script>
